<template>
    <span
        class="uk-badge"
        :class="colorClass"
        :uk-tooltip="tooltip"
        style="text-align: center;"
    >
        {{ formattedValue }}
    </span>
</template>

<script>

import { RefundStatuses } from "../../helpers/constants";
import { kebabCaseToWords } from "@strangeanimals/common-vue-components/src/helpers/helpers";

export default {
    props: {
        value: {
            type: String,
            default: function () {
                return "undefined";
            }
        },
        tooltip: {
            type: String,
            default: function () {
                return "";
            }
        }
    },
    computed: {
        formattedValue() {
            return kebabCaseToWords(this.value);
        },
        colorClass() {
            let colorClass = '';
            switch ( this.value ) {
            case RefundStatuses.APPROVED:
            case RefundStatuses.PENDING:
                colorClass += 'uk-badge-warning';
                break;
            case RefundStatuses.FINALISED:
                colorClass += 'uk-badge-success';
                break;
            case RefundStatuses.REJECTED:
            case RefundStatuses.CANCELLED:
                colorClass += 'uk-badge-danger';
                break;
            case RefundStatuses.VERIFY:
                colorClass += 'uk-badge-info';
                break;
            default:
                colorClass = 'uk-badge-undefined';
            }
            return colorClass;
        }
    }
}
</script>
